var $74fbc8121aba83f1$exports = {};
$74fbc8121aba83f1$exports = {
    "colorSwatchPicker": `Farbfelder`,
    "dropzoneLabel": `Ablegebereich`,
    "selectPlaceholder": `Element w\xe4hlen`,
    "tableResizer": `Gr\xf6\xdfenanpassung`
};


export {$74fbc8121aba83f1$exports as default};
//# sourceMappingURL=de-DE.mjs.map
